/**
 * Model brands the landing page is allowed to name.
 *
 * Every entry corresponds to a family that is seeded and routable today
 * (see backend/inferencing/models/companies). Logo paths are the same
 * `models/logos/…` assets the in-app model picker serves via the CDN, so the
 * page never invents a brand we don't ship.
 */
export const MODEL_CDN = 'https://cdn.gab.ai/';

export const MODEL_BRANDS = [
  { name: 'GPT', logo: 'models/logos/gpt-6-astra-f445f49e5236.png', color: '#10A37F' },
  { name: 'Claude', logo: 'models/logos/1bc70977-71c0-4ba8-80e5-f6bf5f52daa7.png', color: '#D97757' },
  { name: 'Gemini', logo: 'models/logos/1a83f796-ed14-40d2-82d1-797af18ee822.png', color: '#4E82E8' },
  { name: 'DeepSeek', logo: 'models/logos/669a8da5-ab82-4f97-8f90-fc7c4cabb1a5.png', color: '#4D6BFE' },
  { name: 'Qwen', logo: 'models/logos/3dd3191d-2e09-49c8-a2f2-4d91d20539f5.png', color: '#615CED' },
  { name: 'Kimi', logo: 'models/logos/eb979ce5-5a7b-4fd8-ab49-a0df9671f3ed.png', color: '#1F1F1F' },
  { name: 'GLM', logo: 'models/logos/ee6b1944-d891-472d-b900-03d818eb4040.png', color: '#3B5BDB' },
  { name: 'Arya', logo: 'models/logos/1db8672e-2021-4512-a52b-3f70da350738.png', color: '#123524' },
  { name: 'Seedream', logo: 'models/logos/d739f3c2-b78f-4321-8b48-85c4915269d3.png', color: '#2563EB' },
  { name: 'Wan', logo: 'models/logos/7cbccf9f-44f6-4fd5-8f33-83bfd0991da2.png', color: '#7C3AED' },
  { name: 'Kling', logo: 'models/logos/f9d0e88e-d8a9-475d-8b8d-cc8673b9a8fe.png', color: '#0EA5E9' },
  { name: 'MiniMax', logo: 'models/logos/5aace96a-b1f0-49a5-9293-caa9965a3cb5.png', color: '#E11D48' },
];

/** Families without a logo asset on hand render as a monogram in this colour. */
const MONOGRAM_COLORS = {
  'GPT Image': '#10A37F',
  Flux: '#111111',
  Veo: '#4E82E8',
  Grok: '#111111',
  Imagen: '#4E82E8',
  Hailuo: '#E11D48',
  ElevenLabs: '#111111',
  Perplexity: '#20808D',
  Ideogram: '#6D28D9',
  Recraft: '#111111',
  Meshy: '#F59E0B',
  Hunyuan: '#0EA5E9',
};

export function modelBrand(name) {
  const known = MODEL_BRANDS.find((brand) => brand.name === name);
  if (known) return { ...known, uri: `${MODEL_CDN}${known.logo}` };
  if (name === 'GPT Image') {
    const gpt = MODEL_BRANDS.find((brand) => brand.name === 'GPT');
    return { name, logo: gpt.logo, color: gpt.color, uri: `${MODEL_CDN}${gpt.logo}` };
  }
  return { name, logo: null, uri: null, color: MONOGRAM_COLORS[name] || '#6B7280' };
}

/** Breadth signal for tickers. Family names only, no version numbers to go stale. */
export const MODEL_FAMILIES = [
  'GPT', 'Claude', 'Gemini', 'Grok', 'DeepSeek', 'Qwen', 'Kimi', 'GLM', 'Arya',
  'Veo', 'Kling', 'Seedance', 'Seedream', 'Flux', 'Imagen', 'Nano Banana',
  'Wan', 'Hailuo', 'MiniMax Music', 'ElevenLabs', 'Perplexity', 'Ideogram',
  'Recraft', 'Meshy', 'Hunyuan', 'Tripo', 'HeyGen', 'Hermes',
];

/** Number of distinct provider directories seeded under models/companies. */
export const MODEL_LAB_COUNT = 25;
